import { type FC } from "react";
import { ChangePensionContributionStepperWrapper } from "./ChangePensionContributionStepperWrapper";
import { PensionQuestionnaireStepperWrapper } from "./PensionQuestionnaireStepperWrapper";
import { StepperLoader } from "./StepperLoader";

export const StepperManager: FC = () => {
    return (
        <>
            <StepperLoader />
            <ChangePensionContributionStepperWrapper />
            <PensionQuestionnaireStepperWrapper />
        </>
    );
};
